/**
 * Matches a closing tag (`</div>`), a void tag (`<br />`) or a doctype declaration.
 * Deliberately does not try to match a full element to stay linear in the input length,
 * a template that is worth parsing as html always contains at least one of those.
 */
const HTML_MARKUP_REGEX =
  /<\/[a-z][a-z0-9-]*\s*>|<(?:br|hr|img|input|meta|link|source|area|col|embed)\b[^>]*>|<!doctype\s+html/i;

/**
 * Checks whether a string contains html markup.
 *
 * Used to detect if plain text is actually html source code, e.g. when a full html email
 * template is copied from a code editor: in that case the clipboard only holds `text/plain`
 * and the markup would end up escaped instead of being parsed.
 *
 * @param value the string to check
 */
export function isHtmlString(value?: string | null): boolean {
  if (!value) return false;

  return HTML_MARKUP_REGEX.test(value);
}

/** Escapes `& < > " '` so a value can be safely interpolated into an HTML string (e.g. a chart tooltip). */
export function escapeHtml(value: unknown): string {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
